import { useContext } from "react";
import { PromotionsContext } from "../features/promotions/contexts/promotionsContext";
import { promotionsContextType } from "../features/promotions/types/promotionTypes";

export const usePromotionsContext = () => {
  const context = useContext(PromotionsContext) as promotionsContextType
  return context;
}
